export const WORKSHOP_PROJECTS = [
  {
    id: "support",
    title: "OpenAI Issue Classifier",
    type: "Fubo · production system",
    metric: "From tickets to categorized issues",
    description:
      "Architected and deployed a React / TypeScript / Node dashboard for real-time issue tracking. An OpenAI-powered classifier automates ticket categorization, reducing manual triage and helping teams make sense of incoming customer issues.",
    linkLabel: "Discuss this system",
  },
  {
    id: "agents",
    title: "MCP + Agent Systems",
    type: "AI engineering",
    metric: "Context → tools → actions",
    description:
      "Built a custom MCP server used with Claude and implemented tool-calling patterns in production. Paired this with Cursor-assisted test scaffolding, refactoring, and reviewable iteration to connect AI capabilities with everyday engineering work.",
    linkLabel: "Discuss agent tooling",
  },
  {
    id: "relive",
    title: "ReliveInColor",
    type: "Independent product",
    metric: "Your photos, a new way to create",
    description:
      "Transforms personal photos into an interactive coloring experience with a path toward a physical keepsake. Explore the product and try it with a memory of your own.",
    href: "https://reliveincolor.com",
    linkLabel: "Visit ReliveInColor",
  },
  {
    id: "travel-agent",
    title: "Travel Agent Skills",
    type: "Personal AI",
    metric: "60+ countries of context",
    description:
      "Travel-focused skills and agent workflows grounded in years of real trip planning and first-hand travel experience. An exploration of how personal context can make AI planning more useful.",
    linkLabel: "Discuss travel workflows",
  },
  {
    id: "tag-agent",
    title: "Tag Implementer",
    type: "Agent workflow",
    metric: "Sheet → validate → implement",
    description:
      "Turns structured tag requirements from Google Sheets into a tool-driven implementation and validation workflow, connecting a familiar planning surface to engineering actions.",
    linkLabel: "Discuss this workflow",
  },
];
